import React, { PropsWithChildren } from 'react';
import DossierActionProvider from '@europrocurement/l2d-modules/modules/Dossiers/providers/DossierActionProvider';
import { DossierValidatorsProvider } from './DossierValidatorsProvider';
import { FormalitiesProvider } from './FormalitiesProvider';
import { FormulairesProvider } from './FormulairesProvider';
import { UsersProvider } from './UsersProvider';
import { TiersProvider } from './TiersProvider';

import CurrentDossierProviderAndDocumentsWrapper from './CurrentDossierProviderAndDocumentsWrapper';
import { DriveDocumentsProvider } from './DriveDocumentsProvider';

export type GlobalDataProviderProps = {
    formalities?: boolean;
    forms?: boolean;
    validators?: boolean;
    users?: boolean;
};

export const GlobalDataProvider: React.FunctionComponent<
    PropsWithChildren<GlobalDataProviderProps>
> = function ({ formalities = true, forms = true, validators = true, users = true, children }) {
    return (
        <TiersProvider autoload={false}>
            <DossierValidatorsProvider autoload={validators}>
                <UsersProvider autoload={users}>
                    <FormalitiesProvider autoload={formalities}>
                        <FormulairesProvider autoload={forms}>
                            <CurrentDossierProviderAndDocumentsWrapper>
                                <DossierActionProvider>
                                    <DriveDocumentsProvider>{children}</DriveDocumentsProvider>
                                </DossierActionProvider>
                            </CurrentDossierProviderAndDocumentsWrapper>
                        </FormulairesProvider>
                    </FormalitiesProvider>
                </UsersProvider>
            </DossierValidatorsProvider>
        </TiersProvider>
    );
};
